import React, {useEffect, useState} from "react";
import {db} from "../config/firebase-config";
import {
  doc,
  updateDoc,
  arrayUnion,
  addDoc,
  collection,
  deleteDoc,
} from "firebase/firestore";
import MsgBox from "./MsgBox";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Container} from "react-bootstrap";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import useAuthorization from "../auth/useAuthorization";

const ModalDeleteMangel = (props) => {
  const {canWrite} = useAuthorization();
  const today = new Date();

  const [kategorie, setKategorie] = useState("");
  const [kategorieOld, setKategorieOld] = useState("");
  const [status, setStatus] = useState("");
  const [statusOld, setStatusOld] = useState("");
  const [kontaktName, setKontaktName] = useState("");
  const [kontaktEmail, setKontaktEmail] = useState("");
  const [kontaktTelefon, setKontaktTelefon] = useState("");
  const [kilometer, setKilometer] = useState("");
  const [beschreibung, setBeschreibung] = useState("");
  const [prio, setPrio] = useState(4);
  const [prioOld, setPrioOld] = useState(4);
  const [cannotSave, setCannotSave] = useState(true);

  useEffect(() => {
    setStatus(props.mangel.status);
    setStatusOld(props.mangel.status);
    // Der Bestand enthält die Priorität teils als String; das Regelwerk
    // verlangt im Protokoll eine Zahl.
    setPrio(Number(props.mangel.priorität));
    setPrioOld(Number(props.mangel.priorität));
    setKategorie(props.mangel.kategorie);
    setKategorieOld(props.mangel.kategorie);
    setKontaktName(props.mangel.kontaktName);
    setKontaktEmail(props.mangel.kontaktEmail);
    setKontaktTelefon(props.mangel.kontaktTelefon);
    setKilometer(props.mangel.kilometer);
  }, [props.mangel]);

  const handleDelete = () => {
    if (!canWrite) {
      return;
    }

    const dbLink = "fahrzeuge/" + props.fahrzeug.id + "/maengel";
    const docRef = doc(db, dbLink, props.mangel.id);

    deleteDoc(docRef)
      .then(() => {
        writeToProtokoll(props.mangel.id);
      })
      .catch((error) => {
        console.log(error);
      });

    props.close();
  };

  const writeToProtokoll = (id) => {
    const path = "fahrzeuge/" + props.fahrzeug.id + "/protokoll";
    const docRef = collection(db, path);

    let data = {
      status: "Gelöscht",
      statusOld: statusOld,
      statusNew: status,
      prioOld: prioOld,
      prioNew: prio,
      kategorieOld: kategorieOld,
      kategorieNew: kategorie,
      kategorie: kategorie,
      kontaktName: "Admin",
      priorität: prio,
      kilometer: kilometer,
      beschreibung: beschreibung,
      nutzerkreis: "",
      datum: today,
      mangelId: id,
    };

    // Atomically add a new region to the "regions" array field.
    addDoc(docRef, data);
  };

  const handleClose = () => {
    props.close();
  };

  return (
    <>
      <Modal show={props.showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Fahrzeugmangel</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container>
            Möchtest du den aktuellen Mangel wirklich unwiderruflich löschen?
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Abbrechen
          </Button>
          <Button variant="primary" onClick={handleDelete} disabled={!canWrite}>
            Löschen
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalDeleteMangel;
